import Highway from '@dogstudio/highway'

import modular from 'modujs'
import * as modules from './modules'
import FadeTransition from './modules/FadeTransition'
import Scroller from './modules/Scroller'
import { handleAnchorScroll } from './utils/scroll'
import { classesInjection, rewriteLinks } from './utils/transitions'

const Modular = modular
const app = new Modular({
  modules
})

class DefaultRenderer extends Highway.Renderer {
  onEnterCompleted () {
    handleAnchorScroll()
    rewriteLinks()
    app.init(app)
    return this
  }

  onLeaveCompleted () {
    app.destroy()
    return this
  }
}

const init = () => {
  classesInjection()
  new Scroller()

  const H = new Highway.Core({
    renderers: {
      default: DefaultRenderer
    },
    transitions: {
      default: FadeTransition
    }
  })

  H.on('NAVIGATE_IN', ({ trigger }) => {
    app.destroy()
    window.lenis.start()
    if (trigger !== 'popstate') {
      window.lenis.scrollTo(0, {
        lock: true,
        immediate: true
      })
    }
  })

  window.H = H
}

document.addEventListener('DOMContentLoaded', init)
